<template>

  <!-- loading / error -->
  <Column v-if="!item" full class="mainmenu" padding="30px 40px">
    <p class="desc">{{ status }}</p>
  </Column>

  <!-- account -->
  <Column v-else full class="mainmenu" padding="30px 40px">

      <!-- title -->
      <div class="column">
        <div class="row ch" style="gap: 8px;">
          <p class="mini pointer click" @click="copyText(item.id)">ID: {{ item.id }}</p>
          <p class="mini" v-if="item.created">{{ tools.ago(item.created) }}</p>
          <!-- <div class="row ch" style="gap: 8px;"> -->
            <img style="width: 16px; height: 16px;" :src="`/images/icons/providers/${ providerIconName(item.provider)}.svg`" >
            <p class="mini pointer click" @click="copyText(item.email)">{{ item.email }}</p>
          <!-- </div> -->

        </div>

        <div class="row ch" style="gap: 16px;">

          <!-- image -->
          <div v-if="item.image" class="avatar column center pointer click" v-upload.images="uploadAvatar" :style="{background: `url(${item.image || ''}) no-repeat center center`}" style="background-size: cover" >
            <!-- <svg v-if="!item.image" width="44" height="34" viewBox="0 0 44 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M42.5722 28.0829C42.5722 29.5982 42.1902 30.7816 41.4261 31.6331C40.6746 32.4972 39.4848 32.9293 37.8565 32.9293H5.31682C3.96413 32.9293 2.9684 32.5536 2.32963 31.8022C1.70339 31.0634 1.32764 29.905 1.20239 28.3271L8.30401 21.8088C8.67976 21.4457 9.06177 21.1764 9.45004 21.0011C9.85084 20.8258 10.2767 20.7381 10.7276 20.7381C11.191 20.7381 11.6294 20.832 12.0427 21.0199C12.4685 21.2077 12.8819 21.477 13.2827 21.8276L16.8147 25.0773L25.3629 17.432C25.8138 17.0438 26.271 16.7495 26.7344 16.5492C27.1978 16.3488 27.6926 16.2486 28.2186 16.2486C28.7697 16.2486 29.2832 16.3551 29.7592 16.568C30.2477 16.7683 30.7111 17.0689 31.1494 17.4696L42.5722 28.0829ZM13.8087 17.2818C12.9946 17.2818 12.2494 17.0877 11.573 16.6994C10.9092 16.2987 10.3769 15.7602 9.97609 15.084C9.57529 14.4077 9.37489 13.6626 9.37489 12.8486C9.37489 12.0471 9.57529 11.3083 9.97609 10.632C10.3769 9.9558 10.9092 9.41731 11.573 9.01657C12.2494 8.61584 12.9946 8.41547 13.8087 8.41547C14.6228 8.41547 15.3618 8.61584 16.0256 9.01657C16.6894 9.41731 17.2217 9.9558 17.6225 10.632C18.0233 11.3083 18.2237 12.0471 18.2237 12.8486C18.2237 13.6626 18.0233 14.4077 17.6225 15.084C17.2217 15.7602 16.6894 16.2987 16.0256 16.6994C15.3618 17.0877 14.6228 17.2818 13.8087 17.2818ZM5.52348 34C3.69485 34 2.31711 33.5366 1.39026 32.6099C0.463422 31.6958 0 30.337 0 28.5337V5.48508C0 3.66924 0.463422 2.30424 1.39026 1.39006C2.31711 0.463352 3.69485 0 5.52348 0H38.4577C40.2989 0 41.6829 0.469613 42.6097 1.40884C43.5366 2.33554 44 3.69429 44 5.48508V28.5337C44 30.337 43.5366 31.6958 42.6097 32.6099C41.6829 33.5366 40.2989 34 38.4577 34H5.52348ZM5.57985 31.6895H38.4202C39.4597 31.6895 40.2613 31.414 40.8249 30.863C41.3886 30.312 41.6704 29.4917 41.6704 28.4022V5.61657C41.6704 4.52707 41.3886 3.70681 40.8249 3.1558C40.2613 2.59227 39.4597 2.3105 38.4202 2.3105H5.57985C4.51523 2.3105 3.70111 2.59227 3.13749 3.1558C2.58639 3.70681 2.31085 4.52707 2.31085 5.61657V28.4022C2.31085 29.4917 2.58639 30.312 3.13749 30.863C3.70111 31.414 4.51523 31.6895 5.57985 31.6895Z" fill="white" fill-opacity="0.6"/></svg> -->
          </div>

          <div class="column">
            <h1>{{ item.name || 'Name' }}</h1>
            <p class="mini" v-if="item.username">@{{ item.username }}</p>
          </div>


        </div>


        <!-- flags -->
          <!-- <div class="row wrap ch" style="gap: 12px; margin-top: 10px;">
            <Switch class="padding" v-model="item.active" @update="update('active', item.active)">Active</Switch>
            <Switch class="padding" v-model="item.verified" @update="update('verified', item.verified)">Verified</Switch>
            <Switch class="padding" v-model="item.kyc" @update="update('kyc', item.kyc)">KYC</Switch>
            <Switch class="padding" v-model="item.premium" @update="update('premium', item.premium)">Premium</Switch>
            <Switch class="padding" v-model="item.vip" @update="update('vip', item.vip)">VIP</Switch>
            <Switch class="padding" v-model="item.team">Team</Switch>
          </div> -->


      </div>

      <!-- tabs -->
      <div class="tabs">
          <router-link
            class="tab"
            v-for="(menu, index) in usermenu"
            :key="index"
            :to="{name: `accounts/page/${menu.id}`, params: {id: id}}">{{ menu.title }}</router-link>
      </div>

      <router-view :key="$route.path" :account="item" @refresh="refresh"></router-view>

   </Column>

</template>
<script>
import { defineComponent } from 'vue';
export default defineComponent({
  mounted() {
    this.id = this.$route.params.id
    this.refresh()
  },
  watch: {
    '$route.params.id'(id){
      if (!id) return
      this.id = id
      this.refresh()
    }
  },
  data() {
    return {
      id: undefined,
      status:'loading...',
      item: undefined,
      error:{},
    }
  },
  computed: {
      user(){
        return this.item
      },
      private(){
        return this.item && this.item.provider == 3
      },
      usermenu(){
        let list = [
          {id:'profile',  title:'Profile'},
          {id:'assets',   title:'Assets'},
          // {id:'history',  title:'History'},
          // {id:'gpt',      title:'GPT'},
          // {id:'settings', title:'Settings'},
          // {id:'support',  title:'Support'},
          // {id:'chats',    title:'Chats'},
          {id:'access',   title:'Access'},
        ]
        if (this.private) list.push({id:'api', title:'API'})
        return list
      },
  },

  methods: {

     async refresh(){
      let id = Number(this.id)
      if (!id || id < 1) {
        this.status = `Error: can't find user ID`
        return
      }

      let res = await this.api.send('admin/accounts/get', {id})
      if (res.error){
        this.status = `Error: ${res.error.code}: ${res.error.id}`
        return
      }
      this.item = res.resp
    },

    async uploadAvatar(file){
      let f = file[0]
      let link = await this.uploadImage(f)
      if (!link) return
      this.update('image', link)
    },

    async uploadImage(file){
        let body = await this.tools.readFileAsBytes(file)
        let res = await this.api.upload.image(body)
        if (res.error){
          console.error(res.error)
          return
        }
        return res.resp.link //link
    },

    // delete user
    async deleteUser(id){
      let res = await this.api.send('admin/accounts/delete',{id})
      if (res.error){
        this.error.delete = res.error.code + ': '+ res.error.id
        return
      }
      this.$router.push({name:'accounts'})
    },

    // update user
    async update(k,v){
      let res = await this.api.send('admin/accounts/update',{id: this.item.id,k,v})
      if (res.error){
        this.error.update = res.error.code + ': '+ res.error.id
        return
      }
      this.refresh()
    },

    providerIconName(p){
      switch (p) {
        case 1: return 'google'
        case 2: return 'apple'
        case 3: return 'private'
        default: return 'email'
      }
    },

  },
});

</script>
<style scoped>

.avatar{
  width: 100px;
  height: 100px;
  border-radius: 200px;
  background: var(--g01);
  border: 0.5px solid var(--g01)
}

</style>
